export default __webpack_public_path__ + "static/media/bkash-pmt.97b99c9f.jpeg";